import React, { Component } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import Footer from 'components/AppFooter/AppFooter';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;

import ClassroomList from 'components/ClassroomList';
import ContentHeader from 'components/ContentHeader';
import Input from 'components/Input';
import Button from 'components/Button';
import ClassroomPanel from 'components/ClassroomPanel';
import Loader from 'components/Loader/Loader';

import { keyedObjToArr } from '../../util';


class Classrooms extends Component {

	constructor (props) {
		super(props);
	}

	createClassroom () {
		let classroom = {};
		this.props.openDrawer(<ClassroomPanel
			classroom={classroom}
			customer={this.props.customer}
			addClassroom={this.addClassroom.bind(this)}
			users={this.props.users}
			schools={this.props.schools}
			products={this.props.products}
			orders={this.props.orders}
		/>);
	}

	editClassroom (classroom) {
		this.props.openDrawer(<ClassroomPanel
			classroom={classroom}
			customer={this.props.customer}
			editing={true}
			saveClassroom={this.saveClassroom.bind(this)}
			users={this.props.users}
			schools={this.props.schools}
			products={this.props.products}
			orders={this.props.orders}
		/>);
	}

	updateClassroomSchool (classroom, classroomId) {
		const { firebase } = this.props;
		if(!this.props.schools[classroom.school]) {
			return;
		}
		let classrooms = this.props.schools[classroom.school].classrooms || {};
		classrooms[classroomId] = true;
		firebase.set(`/schools/${classroom.school}/classrooms/`, classrooms);
	}

	removeClassroomFromSchool (classroom) {
		const { firebase } = this.props;
		keyedObjToArr(this.props.schools).forEach( (school) => {
			if(school.classrooms && school.classrooms[classroom.id]){
				firebase.remove(`/schools/${school.id}/classrooms/${classroom.id}`);
			}
		});
	}

	updateClassroomTeacher (classroom, classroomId) {
		const { firebase } = this.props;
		if(!this.props.users[classroom.teacher]) {
			return;
		}
		let classrooms = this.props.users[classroom.teacher].classrooms || {};
		classrooms[classroomId] = true;
		firebase.set(`/users/${classroom.teacher}/classrooms/`, classrooms);
	}

	removeClassroomFromTeacher (classroom) {
		const { firebase } = this.props;
		keyedObjToArr(this.props.users).forEach( (user) => {
			if(user.classrooms && user.classrooms[classroom.id]){
				firebase.remove(`/users/${user.id}/classrooms/${classroom.id}`);
			}
		});
	}

	addClassroom (classroom) {
		// Add classroom then add it to the school
		const { firebase } = this.props;
		firebase.push('/classrooms', classroom).then( (response) => {
			this.updateClassroomTeacher(classroom, response.key);
			this.updateClassroomSchool(classroom, response.key);
            firebase.set(`/classrooms/${response.key}/id`, response.key);
            this.props.classrooms[response.key] = classroom;
		}).catch( (err) => {
			console.log(err);
		});
	}

	saveClassroom (classroom) {
		const { firebase } = this.props;
		firebase.set(`/classrooms/${classroom.id}`, classroom);
		this.removeClassroomFromTeacher(classroom);
		this.removeClassroomFromSchool(classroom);
		this.updateClassroomTeacher(classroom, classroom.id);
		this.updateClassroomSchool(classroom, classroom.id);
	}

	deleteClassroom (classroom) {
		this.props.openModal(null, {
			message : 'Are your sure you want to delete this classroom?',
			title : 'Delete Classroom',
			onClose : (result) => {
				if (result === true) {
					const { firebase } = this.props;
					firebase.remove(`/classrooms/${classroom.id}`);
					this.removeClassroomFromTeacher(classroom);
					this.removeClassroomFromSchool(classroom);
				}
			}
		});
	}

	//school

	renderSchoolInput() {
		return(
			<div className="main-content-area">
				<div className="content-header">
					<div className="container">
						<h3>Create Your First School</h3>
					</div>
				</div>
				<div className="page-content padded-top">
					<div className="container">

					<form className="flex-grid tight">
						<div className="col grow">
							<Input
								placeholder="School Name"
								onChange={this.setSchoolName.bind(this)}
								value={this.state.schoolName}
							/>
						</div>
						<div className="col no-grow">
							<Button
								label="Create School"
								disabled={!this.state.schoolName}
								onClick={this.addSchool.bind(this)}
							/>
						</div>
					</form>
					</div>
				</div>
			</div>
			);
	}

	render () {

		if( !isLoaded(this.props.profile) ||
				!isLoaded(this.props.products) ||
				!isLoaded(this.props.customer) ||
				!isLoaded(this.props.classrooms) ||
				!isLoaded(this.props.schools) ||
				!isLoaded(this.props.users)
			) {
			return (
				<div className="main-content-area">
					<div className="page-content">
						<Loader color="main" size="large" />
					</div>
					<Footer/>
				</div>
			);
		}

		let classrooms;
        let button;
        let customer;
        let customers;

		//Not admin and not customer
		if(!this.props.profile.customer && this.props.profile.role !== 'admin') {

			return(
				<div className="main-content-area">
					<div className="page-content">
						<div><h3>No Customer for User</h3></div>
					</div>
				</div>
			);
		//Not admin and customer
		}
		else if(this.props.profile.customer && this.props.profile.role !== 'admin') {

			customer = this.props.customer;

			if(!customer.schools) {
				return this.renderSchoolInput();
			}

			let customerSchools = keyedObjToArr(customer.schools).map( (school) => {
				if(!this.props.schools[school.id]) {
					console.warn('couldnt find school with id ' + school.id);
				}
				return this.props.schools[school.id];
			});

			classrooms = customerSchools.reduce( (classrooms, school) => {
				if(school) {
					keyedObjToArr(school.classrooms).forEach( (classroom) => {
						if(this.props.classrooms[classroom.id]) {
							let classroomObj = this.props.classrooms[classroom.id];
							classroomObj.id = classroom.id;
							if (classroomObj.teacher === this.props.profile.id) {
								classrooms.push(classroomObj);
							}
						}
					}, this);
				}

				return classrooms;
			}, []);
		// Admin
		}
		else if(this.props.profile.role === 'admin') {
			classrooms = this.props.classrooms ? keyedObjToArr(this.props.classrooms) : [];
			customers = this.props.customers ? keyedObjToArr(this.props.customer) : [];

            button = (<Button
				label="Create Classroom"
				onClick={this.createClassroom.bind(this)}
			/>);
		}

		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
				transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
			<div className="main-content-area" key="classrooms">
				<ContentHeader
					title="Classrooms"
					button={button}
				/>
				<div className="page-content">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="main-list-area">
									<ClassroomList
										profile={this.props.profile}
										classrooms={classrooms}
										schools={this.props.schools}
										customer={customer}
										customers={customers}
										products={this.props.products}
										users={this.props.users}
										editClassroom={this.editClassroom.bind(this)}
										deleteClassroom={this.deleteClassroom.bind(this)}
										orders={this.props.orders}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</ReactCSSTransitionGroup>
		);
	}
}


const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (id) => { dispatch(openDrawer(id)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		openModal : (modal, props) => { dispatch(openModal(modal, props)); }
	};
};

const fbWrappedComponent = firebaseConnect( ({auth, profile}) => {

	if(!profile){
		return [];
	} else if (profile.customer) {
		return [
			{
				path: 'users',
				storeAs: 'users',
				queryParams: [ 'orderByChild=customer', `equalTo=${profile.customer}`]
			},
			{
				path: 'customers/'+profile.customer,
				storeAs: 'customer'
			},
			{
				path: 'schools',
				storeAs: 'schools',
				queryParams: [ 'orderByChild=customer', `equalTo=${profile.customer}`]
			},
			{
				path: 'orders',
				storeAs: 'orders',
				queryParams: [ 'orderByChild=customer', `equalTo=${profile.customer}`]
			},
			{
				path: 'classrooms',
				storeAs: 'classrooms'
			},
			{
				path: 'products',
				storeAs: 'products'
			}
		];
	} else if (profile.role === 'admin'){
		return [
			{
				path: 'users',
				storeAs: 'users'
			},
			{
				path: 'customers',
				storeAs: 'customer'
			},
			{
				path: 'schools',
				storeAs: 'schools'
			},
			{
				path: 'orders',
				storeAs: 'orders'
			},
			{
				path: 'classrooms',
				storeAs: 'classrooms'
			},
			{
				path: 'products',
				storeAs: 'products'
			}
		];
	}

})(Classrooms);

//Auth
const connectAuth = connect(
	({ firebase }) => {
		return{
			profile: pathToJS(firebase, 'profile'),
		};
	}
)(fbWrappedComponent);

//Export
export default connect(
	({ firebase }) => ({
		classrooms: dataToJS(firebase, 'classrooms'),
		schools: dataToJS(firebase, 'schools'),
		customer: dataToJS(firebase, 'customer'),
		products: dataToJS(firebase, 'products'),
		users: dataToJS(firebase, 'users'),
		orders: dataToJS(firebase, 'orders')
	}),
	mapDispatchToProps
)(connectAuth);





// WEBPACK FOOTER //
// ./js/containers/Classrooms/Classrooms.js